import { Link } from "react-router-dom";
import { FcAddRow } from "react-icons/fc";
const InnerNav = ({ createLink, listLink, notes }) => {
  return (
    // <div className="flex flex-col flex-wrap mb-8 space-y-4 md:flex-row md:items-end md:space-x-4">
    //     <div>
    //         <Link to={createLink} className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
    //         >
    //           <FcAddRow />
    //           <span className="ml-2">New</span>
    //         </Link>
    //     </div>

    // </div>

    <div className="mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      {/* LEFT: Page context */}
      <div>
        <p className="text-sm text-gray-500">{notes}</p>
      </div>

      {/* RIGHT: Actions */}
      <div className="flex gap-2">
        <Link
          to={createLink}
          className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
        >
          <FcAddRow />
          <span className="ml-2">New</span>
        </Link>
      </div>
    </div>
  );
};
export default InnerNav;
